import React, { useState } from "react";
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';

export const ImageViewer = ({ url, thumbnail, width = 300, height = 300, caption }) => {
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const MAX_WIDTH = 300;
    const MAX_HEIGHT = 300;

    const safeWidth = width > MAX_WIDTH ? MAX_WIDTH : width;
    const safeHeight = height > MAX_HEIGHT ? MAX_HEIGHT : height;

    const handleDownload = () => {
        setIsLoading(true);
        setHasStarted(true);

        fetch(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_messenger_token")
            }
        })
            .then(res => {
                const contentLength = +res.headers.get("Content-Length");
                let received = 0;
                const reader = res.body.getReader();
                const chunks = [];

                const readChunk = () => {
                    return reader.read().then(({ done, value }) => {
                        if (done) {
                            const blob = new Blob(chunks);
                            const blobUrl = URL.createObjectURL(blob);
                            setDownloadUrl(blobUrl);
                            setIsLoading(false);
                            return;
                        }
                        chunks.push(value);
                        received += value.length;
                        setProgress(Math.floor((received / contentLength) * 100));
                        return readChunk();
                    });
                };

                return readChunk();
            })
            .catch((err) => {
                if (err.name !== 'AbortError') console.error("Image fetch failed", err);
                setIsLoading(false);
            });
    };

    const imageSrc = downloadUrl || `data:image/jpeg;base64,${thumbnail}`;
    const isDownloaded = !!downloadUrl;

    return (
        <div style={{
            backgroundColor: '#f9f9f9',
            borderRadius: 12,
            padding: 10,
            maxWidth: safeWidth,
            direction: 'rtl',
            textAlign: 'right',
            fontFamily: 'IRANSans'
        }}>
            <div
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    marginBottom: 8,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: isDownloaded ? 'zoom-in' : 'default',
                    width: safeWidth,
                    height: safeHeight
                }}
                onClick={() => isDownloaded && setShowModal(true)}
            >
                <img
                    src={imageSrc}
                    alt="نمایش تصویر"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        borderRadius: 10,
                        display: 'block',
                        filter: !isDownloaded ? 'blur(8px)' : 'none',
                        transition: 'filter 0.3s ease'
                    }}
                />
                {!hasStarted && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <IconButton onClick={handleDownload} size="large" style={{ backgroundColor: '#1976d2', color: '#fff' }}>
                            <DownloadIcon fontSize="medium" />
                        </IconButton>
                    </div>
                )}
            </div>
            {caption && <div style={{ fontSize: 13, color: '#555' }}>{caption}</div>}
            {isLoading && (
                <div style={{ fontSize: 12, color: '#999' }}>
                    در حال دانلود... {progress}%
                </div>
            )}
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1300,
                    cursor: 'zoom-out',
                    flexDirection: 'column'
                }}
                     onClick={() => setShowModal(false)}
                >
                    <img
                        src={imageSrc}
                        alt="بزرگنمایی تصویر"
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                            borderRadius: 8
                        }}
                    />
                    {isDownloaded && (
                        <a
                            href={downloadUrl}
                            download="image.jpg"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                marginTop: 16,
                                textDecoration: 'none'
                            }}
                        >
                            <IconButton
                                size="large"
                                style={{
                                    color: 'white',
                                    backgroundColor: 'rgba(255,255,255,0.1)'
                                }}
                            >
                                <DownloadIcon />
                            </IconButton>
                        </a>
                    )}
                    <IconButton
                        onClick={() => setShowModal(false)}
                        style={{
                            position: 'absolute',
                            top: 16,
                            left: 16,
                            color: 'white',
                            backgroundColor: 'rgba(0,0,0,0.4)'
                        }}
                        size="large">
                        <CloseIcon />
                    </IconButton>
                </div>
            </Modal>
        </div>
    );
};
